<template>
    <b-skeleton class="partners" animation="wave"/>
</template>

<script>
export default {
  name: "PartnersSkeletonBox"
};
</script>
